export default __webpack_public_path__ + "static/media/5.39a0ef1d.png";